import { useMemo } from "react";
import { AccountContainer } from "hooks/useAccount";

export function useUserRoles() {
  const { userRoles } = AccountContainer.useContainer();

  return useMemo(() => {
    const roles = (userRoles || []).map((a) => a.toUpperCase());

    return {
      roles,
      isStudent: roles.includes("STUDENT"),
      isFaculty: roles.includes("FACULTY"),
      isEducationRole: roles.includes("EDUCATION") || roles.includes("FACULTY"),
      isHealthcareRole: roles.includes("HEALTHCARE"),
      isCpnwAdmin: roles.includes("CPNW-ADMIN"),
      isCpnwReviewer: roles.includes("CPNW-REVIEWER"),
    };
  }, [userRoles]);
}
